import React from "react"
import { Modal } from "react-bootstrap"

interface PrevetModalNewVesselNoticeProps {
  show: boolean
  setShowModal: (show: boolean) => void
}

function PrevetModalNewVesselNotice({
  show,
  setShowModal,
}: PrevetModalNewVesselNoticeProps) {
  return (
    <Modal show={show} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Notice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Vessel is newly built. Information may be limited or unavailable.
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn bg-dark text-light"
          onClick={() => setShowModal(false)}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default PrevetModalNewVesselNotice
